import { jsx as _jsx } from "react/jsx-runtime";
import { CheckCircled, Resolve } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { memo, useCallback } from "react";
import { REOPEN_DISCUSSION_BUTTON } from "~/constants/testIDs";
import { useHover } from "~/hooks/useHover";
export const ReopenDiscussionButton = /*#__PURE__*/ memo((param)=>{
    let { onToggleResolve, discussion } = param;
    const { handleUnhover, handleHover, isHovering } = useHover();
    const handleToggleResolveClick = useCallback(()=>{
        onToggleResolve === null || onToggleResolve === void 0 ? void 0 : onToggleResolve({
            annotation: discussion.annotation,
            clipId: discussion.clipId,
            id: discussion.id,
            resolved: !discussion.resolved,
            timestamp: discussion.timestamp
        });
    }, [
        discussion,
        onToggleResolve
    ]);
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: "Re-open",
        side: "top",
        children: /*#__PURE__*/ _jsx(IconButton, {
            "data-testid": REOPEN_DISCUSSION_BUTTON,
            onMouseEnter: handleHover,
            onMouseLeave: handleUnhover,
            icon: isHovering ? Resolve : CheckCircled,
            className: "ml-1 text-grey-9",
            appearance: "ghost",
            color: "grey",
            size: "small",
            onClick: handleToggleResolveClick,
            label: "Reopen"
        })
    });
});
ReopenDiscussionButton.displayName = "ReopenDiscussionButton";
